export default [
  {
    path: '/links-generator-workflow',
    name: 'PageLinksGeneratorWorkflowList',
    meta: { title: 'linksGeneratorWorkflow.listTitle', roles: ['ADMIN'], permissions: ['link_generator'] },
    component: () => import('@/pages/links-generator-workflow'),
  },
]